import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FuturevoterEligibleHeader } from '~components/Futurevoter/FuturevoterEligibleContent';
import FutureVoterDownloadPDFContent from '~components/Futurevoter/FutureVoterDownloadPDFContent';
import SameDayRegistrationAlert from '~components/common/SameDayRegistrationAlert';
import { CustomizableButton } from '../common/Button';
import ContentDiv from '../common/ContentDiv';
import { useStateField, useStateName } from '../../state/getStateField';
import Markdown from '../common/Markdown';
import useRegisterRedirect from './useRegisterRedirect';

function DownloadPDF({ tool, successPage }) {
  const person = useSelector((state) => state.person);
  const registerFields = useSelector((state) => state.registerFields);
  const futurevoterFields = useSelector((state) => state.futurevoterFields);
  const fields = tool === 'futurevoter' ? futurevoterFields : registerFields;
  const stateName = useStateName();
  const customMailDirections = useStateField('registration_directions_mail');

  const ovrLink = fields.ovr_link;

  const successUrl =
    successPage === 'donate'
      ? `/tools/${tool}/donate/`
      : `/tools/${tool}/share/`;

  useRegisterRedirect('download-pdf', tool);
  if (!fields.uuid) {
    return null;
  }

  return (
    <ContentDiv>
      {/* We only want the custom FutureVoter eligibility header if this is the first screen they are seeing after the intake (i.e. OVR isn't available) */}
      {tool === 'futurevoter' && !ovrLink ? (
        <FuturevoterEligibleHeader displayGoodNews={false} />
      ) : (
        <>
          <SameDayRegistrationAlert />
          <h1>We&apos;re preparing your form now</h1>
        </>
      )}
      {tool === 'futurevoter' ? (
        <FutureVoterDownloadPDFContent ovrLink={ovrLink} />
      ) : (
        <ol>
          <li>
            We&apos;ll email your voter registration form to{' '}
            {person.email ? <strong>{`${person.email}`}</strong> : 'you'}. If
            you are unable to find it, check your spam folder.
          </li>
          <li>Print your form.</li>
          <li>Sign and date where indicated.</li>
          <li>Mail your form to the address provided.</li>
        </ol>
      )}
      {customMailDirections && (
        <>
          <h2>{`Special instructions for ${stateName} voters`}</h2>
          <Markdown content={customMailDirections} />
        </>
      )}
      <CustomizableButton
        to={successUrl}
        data-element-id={`btn_${tool}_download-pdf_continue`}
        state={{ variant: 'form-emailed' }}
        elementType='Link'
      >
        Continue
      </CustomizableButton>
    </ContentDiv>
  );
}

DownloadPDF.propTypes = {
  tool: PropTypes.oneOf(['register', 'futurevoter']),
  successPage: PropTypes.oneOf(['donate', 'share']),
};

DownloadPDF.defaultProps = {
  tool: 'register',
};

export default DownloadPDF;
